import { actions } from 'entities';

import { DownloadFileIcon } from 'components/Icons';

import { registerProjectOption } from '../options';

registerProjectOption({
  Icon: DownloadFileIcon,

  getLabel: (t) => t('pdf-direct-costs'),

  action: 'DOWNLOAD_SIMPLE_PDF',

  shortcut: {
    key: 'P',
    triggerKey: 'ctrl',
    visualOnly: true,
  },

  useOption: ({ project }) => {
    const download = actions.projects.downloadPDF.use({
      params: {
        projectId: project.id,
        type: 'DIRECT_COSTS',
        name: project.name,
      },
    });

    return {
      action: async () => {
        download.onClick();
      },

      loading: download.loading,

      isEnabled: true,
    };
  },
});

registerProjectOption({
  Icon: DownloadFileIcon,

  getLabel: (t) => t('pdf-breakdown'),

  action: 'DOWNLOAD_SERVICE_BREAKDOWN_PDF',

  shortcut: {
    key: 'P',
    triggerKey: 'ctrl',
    visualOnly: true,
  },

  useOption: ({ project }) => {
    const download = actions.projects.downloadPDF.use({
      params: {
        projectId: project.id,
        type: 'WITH_SERVICES_BREAKDOWN',
        name: project.name,
      },
    });

    return {
      action: async () => {
        download.onClick();
      },

      loading: download.loading,

      isEnabled: true,
    };
  },
});
